import { CustomProperty } from "@/models/CustomProperty";

/** The property's own group (or groups) when Geotab returns one, otherwise the fallback. */
function getCustomPropertyGroupName(customProperty: CustomProperty, fallbackGroupName: string) {
  const propertyRecord = customProperty.property as unknown as Record<string, unknown>;
  const propertyGroup = propertyRecord.group as { name?: string } | undefined;
  if (propertyGroup?.name) return propertyGroup.name;

  const propertyGroups = propertyRecord.groups as { name?: string }[] | undefined;
  const names = (propertyGroups ?? []).map(group => group.name).filter(Boolean);
  return names.length > 0 ? names.join(", ") : fallbackGroupName;
}

/** Groups sorted by name, with the fallback group last in every language. */
export function groupCustomProperties(
  customProperties: CustomProperty[],
  fallbackGroupName: string,
): [string, CustomProperty[]][] {
  const byGroup = new Map<string, CustomProperty[]>();
  for (const customProperty of customProperties) {
    const groupName = getCustomPropertyGroupName(customProperty, fallbackGroupName);
    byGroup.set(groupName, [...(byGroup.get(groupName) ?? []), customProperty]);
  }

  return [...byGroup.entries()].sort(([a], [b]) => {
    if (a === fallbackGroupName) return 1;
    if (b === fallbackGroupName) return -1;
    return a.localeCompare(b);
  });
}
